import Seo, { localBusinessLd } from "../lib/seo";
import RecoveryPath from "../components/site/RecoveryPath";
import HomeHero from "../components/home/HomeHero";
import TrustBar from "../components/home/TrustBar";
import ConditionCards from "../components/home/ConditionCards";
import EmpathySection from "../components/home/EmpathySection";
import ServicesSnapshot from "../components/home/ServicesSnapshot";
import MeetTheSpecialists from "../components/home/MeetTheSpecialists";
import GoogleReviewsGrid from "../components/home/GoogleReviewsGrid";
import TestimonialsGrid from "../components/home/TestimonialsGrid";
import FinalCTA from "../components/home/FinalCTA";

export default function Home() {
  return (
    <div>
      <Seo
        title="Physio Hyve Clinic | Physiotherapy & Rehabilitation in Nangloi, Delhi"
        description="Personalised physiotherapy for pain, injuries, neurological conditions and post-surgical recovery. 4.8★ Google rating · 157 patient reviews · Nangloi, West Delhi."
        path="/"
        image="/logo-icon-256.png"
        jsonLd={localBusinessLd()}
      />
      <section className="relative overflow-hidden">
        <HomeHero />
        <TrustBar />
      </section>
      <ConditionCards />
      <EmpathySection />
      <RecoveryPath />
      <ServicesSnapshot />
      <MeetTheSpecialists />
      <TestimonialsGrid />
      <FinalCTA />
    </div>
  );
}
